import { HTMLAttributes, MouseEventHandler, ReactNode } from 'react';
import { Button, ButtonSize, ButtonVariant } from '../Button';
import { Icon, IconName } from '../Graphics';
import { AlertVariant } from './enums';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';

export type AlertProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  /**
   * An event that will fire when the dismiss button is clicked.
   * If not provided, the dismiss button is not shown.
   */
  onDismiss?: MouseEventHandler<HTMLButtonElement>;
  /**
   * Use enum `AlertVariant`
   */
  variant?: AlertVariant;
  inline?: boolean;
};

export const Alert = ({
  children,
  onDismiss,
  variant = AlertVariant.Grey,
  inline = false,
  className,
  ...props
}: AlertProps) => (
  <div
    className={joinClassNames(styles.alert, styles[variant], className, inline && styles.inline)}
    {...props}
  >
    <div className={styles.content}>{children}</div>
    {onDismiss && (
      <Button
        variant={ButtonVariant.Transparent}
        size={ButtonSize.Small}
        onClick={onDismiss}
        aria-label="Close Alert"
      >
        <Icon name={IconName.Close} marginLeft="small" aria-hidden="true" />
      </Button>
    )}
  </div>
);
